<template>
  <div :class="elementClass" @click="click">
    <span class="first-icon" ref="firstIcon">
      <slot name="firstIcon"></slot>
    </span>
    <span class="main-text" style="display: inline-block">
      <slot></slot>
    </span>
    <span class="second-icon" ref="secondIcon">
      <slot name="secondIcon"></slot>
    </span>
  </div>
</template>

<script>
import { listItemClass } from "../prefix";
import Helper from "../helper";
export default {
  computed: {
    elementClass() {
      return listItemClass;
    },
  },
  methods: {
    click() {
      this.$emit("click");
    },
    open() {
      Helper.addClass(this.$refs.secondIcon, "open");
      Helper.addClass(this.$refs.firstIcon, "open");
    },
    close() {
      Helper.removeClass(this.$refs.secondIcon, "open");
      Helper.removeClass(this.$refs.firstIcon, "open");
    },
  },
};
</script>
